// src/components/experimental/positionNBackExact/PositionNBackExactConstants.js
export const DEFAULT_N_LEVEL = 1;
export const DEFAULT_NUM_TRIALS = 20;
export const DEFAULT_ISI_MS = 2500; // Inter-stimulus interval
export const GRID_SIZE = 3; // 3x3 grid
export const STIMULUS_DURATION_MS = 500; // How long the current stimulus is shown